import React from 'react';
import { Grid, useMediaQuery, useTheme } from '@material-ui/core';
import makeStyles from '@material-ui/core/styles/makeStyles';
import clsx from 'clsx';

const useStyles = makeStyles(
  {
    root: {
      fontSize: 13
    },
    title: {
      fontSize: 12,
      color: '#999999',
      textTransform: 'uppercase',
      '&$normalPadding': {
        paddingBottom: 8
      }
    },
    normalPadding: {}
  },
  { name: 'DataDisplay' }
);

/**
 * Component for showing data.
 *
 * @param  {JSXElement} children   Data to be displayed
 * @param  {string} area   String passed to gridArea style, to handle CSS grid responsiveness
 * @param  {JSXElement} title   Element that will be used as title for the data
 * @param  {"dense" | "normal"} titlePadding   Element that will be used as title for the data
 * @param  {boolean} responsive   Set it to false to always display title.
 * @param  {string} dataClassName   String passed to style child elements via material-ui style.
 */
const DataDisplay = ({
  children,
  area,
  title,
  titlePadding = 'dense',
  responsive = true,
  dataClassName = ''
}) => {
  const classes = useStyles();
  const theme = useTheme();
  const md = useMediaQuery(theme.breakpoints.up('md'));

  return (
    <div
      style={ { gridArea: area } }
      className={ classes.root }
    >
      {title && ((responsive && !md) || !responsive) ? (
        <Grid container direction={ 'column' }>
          <Grid item className={ clsx(classes.title, {
            [classes.normalPadding]: titlePadding === 'normal'
          } ) }>
            {title}
          </Grid>
          <Grid className={ dataClassName } item>{children}</Grid>
        </Grid>
      ) : (
        children
      )}
    </div>
  );
};

export default DataDisplay;
